export enum LoginFormStep {
  stepRedirectFromELicensing,
  stepBasicLogin,
  stepContact,
  stepAuthenticateCode,
  stepSuperUser,
  stepAccount,
  stepNoAccounts,
  stepMfa,
}
